var path = '/templates/zenclerk_s/common/maintenance/maintenance.html';
var html = "<div class=maintenance><img src=/assets/img/logo-aideal.svg><h1>{{ 'common.maintenance.maintenanceInProgress' | translate }}</h1><p>{{ 'common.maintenance.description' | translate }}</p></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/common/maintenance/maintenance.html
// module id = 1312
// module chunks = 0